/**
 * @generated SignedSource<<f79750cd3a383bdbed67bcbebb800aa2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DSAReportProblemType = "Accessibility" | "ConsumerProtection" | "Disinformation" | "IllegalContents" | "Other" | "PrivacyRequest" | "ProtectionOfMinors" | "TransparencyForOnlineAds" | "UserRightsAndComplaints";
export type DSAReportType = "Complaint" | "Feedback" | "Other" | "Report";
export type CreateReportInput = {
  clientMutationId?: string | null;
  data: DSAReportDataInput;
};
export type DSAReportDataInput = {
  email?: string | null;
  extra?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  problemType: DSAReportProblemType;
  reportType: DSAReportType;
  url?: string | null;
};
export type createReportModal_createReportMutation$variables = {
  input: CreateReportInput;
};
export type createReportModal_createReportMutation$data = {
  readonly Reports: {
    readonly createReport: {
      readonly referenceNumber: string;
    } | null;
  };
};
export type createReportModal_createReportMutation = {
  response: createReportModal_createReportMutation$data;
  variables: createReportModal_createReportMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ReportsMutations",
    "kind": "LinkedField",
    "name": "Reports",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "CreateReportPayload",
        "kind": "LinkedField",
        "name": "createReport",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "referenceNumber",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createReportModal_createReportMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createReportModal_createReportMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "96d54093edece5e46941b0b35a81771a",
    "id": null,
    "metadata": {},
    "name": "createReportModal_createReportMutation",
    "operationKind": "mutation",
    "text": "mutation createReportModal_createReportMutation(\n  $input: CreateReportInput!\n) {\n  Reports {\n    createReport(input: $input) {\n      referenceNumber\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "53a44225a43a6ab19f82dcbe388d642d";

export default node;
